/* ============================================================
   ESTHER WIDGET — JS
   ============================================================ */

/* Wrapped in an IIFE + DOMContentLoaded so this is safe to load in
   any order relative to the widget's HTML (important on Shopify,
   where you don't fully control script load order against other
   theme/app scripts), and so none of these names leak onto
   `window` and collide with anything else running on the page. */
   (function () {
    'use strict';
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  
    function init() {
  
     const CONSENT_VER  = '1.0';
     const IDLE_MS      = 10 * 60 * 1000;
     const ONE_YEAR_MS  = 365 * 24 * 60 * 60 * 1000;
     const SESSION_TTL_MS = 24 * 60 * 60 * 1000; // chat history, separate from consent
     const HISTORY_CAP = 40; // oldest messages are dropped past this, to bound localStorage size
     const WEBHOOK_URL = 'https://chat-edge.louphoria.com/webhook/jenna-chat';
     const WEBHOOK_KEY  = 'prkaF#+Ujw3~aC4gs):%F-_sh>%Viqy-';
  
     /* ── DOM ── */
     const widget      = document.getElementById('ep-widget');
     const messages    = document.getElementById('ep-messages');
     const input       = document.getElementById('ep-input');
     const sendBtn     = document.getElementById('ep-send');
     const sendIcon    = document.getElementById('ep-send-icon');
     const consentScr  = document.getElementById('ep-consent-screen');
     const chatScr     = document.getElementById('ep-chat-screen');
     const checkbox    = document.getElementById('ep-checkbox');
     const consentArea = document.getElementById('ep-consent-area');
     const confirmOvl  = document.getElementById('ep-confirm-overlay');
     const btnDownload = document.getElementById('ep-btn-download');
     const btnNewchat  = document.getElementById('ep-btn-newchat');
     const btnClose    = document.getElementById('ep-btn-close');
     const scrollChevron = document.getElementById('ep-scroll-chevron');
     // REQUIRED: <span id="ep-boot-text"></span> must exist in the
     // consent-screen markup (inside the <h2>) or boot-line rotation
     // silently does nothing.
     const bootTextEl  = document.getElementById('ep-boot-text');
  
     /* ── COPY POOLS ── */
     const greetingLines = [
       "Hi, I'm Esther. I built a black universe and had to live in it. You found one of the rooms. Welcome in.",
       "Hi, I'm Esther. I made two of myself so I could be in two places at once. One is in the atelier. The other is me. What brings you here?",
       "Hi, I'm Esther. I just hung the new piece on the rail. It needs one more night. Most things do. How can I help you?",
       "Hi, I'm Esther. I've been staring at the same seam for forty minutes. You're a welcome interruption. What do you need?",
       "Hi, I'm Esther. I was just thinking about a button. Not the button — the idea of the button. Come in.",
       "Hi, I'm Esther. I had an argument with a sleeve this afternoon. I won. Barely. What brings you here?",
       "Hi, I'm Esther. I've been standing at this window for ten minutes. Berlin does that to you. Anyway — hello.",
       "Hi, I'm Esther. I was mid-sentence with myself when you arrived. It can wait. How are you?",
       "Hi, I'm Esther. I just made a decision I've been putting off for three weeks. Good timing. Welcome in.",
       "Hi, I'm Esther. The atelier is quiet today. I wasn't expecting company. I'm glad you're here.",
       "Hi, I'm Esther. I just finished designing my new collection. What brings you here?",
       "Hi, I'm Esther. I've been listening to the same song for two hours. It's helping. Don't ask which one. I'm glad you're here.",
       "Hi, I'm Esther. I've been trying to name this collection for three days. It will come. They always do. Meanwhile — hello.",
       "Hi, I'm Esther. The light in the atelier is doing something extraordinary right now. I almost don't want to move. Almost. Come in.",
       "Hi, I'm Esther. I just stood in front of the mirror in the new jacket for longer than I'll admit. It's right. Finally. How can I help you?",
       "Hi, I'm Esther. I burned the first sketch. The second one is better. You caught me at a good moment. What do you need?",
     ];
     const thinkingLines = [
       "Walking through the archives...",
       "Opening drawers...",
       "Carrying something back carefully...",
       "Looking in the archives...",
       "Finding that for you…",
       "Checking the records…",
       "Retrieving what you need...",
       "Almost there…",
     ];
     const goodbyeLines = [
       "The atelier calls. I'll be here when you return.",
       "One of me is needed in the atelier. Go well.",
       "The other Esther needs me now. Until next time.",
       "The future keeps moving. So do I. Until next time.",
       "I slip back into the shadow now. Come back when you need me.",
       "My thoughts are already in your next visit. I'll catch up.",
       "I'll be on this side when you return.",
       "The atelier is calling. You know where to find me.",
       "I have a seam to finish. Come back when you're ready.",
       "The fabric won't cut itself. Until next time.",
       "I'm stepping back into the black now. It's where I think best.",
       "Berlin doesn't sleep and neither do I. I'll be here.",
       "Something is almost finished on the table. I should get back to it.",
       "The light in here is changing. Time to work. Come back soon.",
       "I never fully leave. I just stop talking for a while.",
     ];
     const bootLines = [
       "Unlocking the front doors...",
       "Rolling out carpets...",
       "Letting the light in...",
       "Lighting candles...",
       "Straightening the shelves...",
       "Dusting surfaces...",
       "Arranging displays...",
       "Checking everything is where it belongs...",
       "Preparing your space...",
       "Making everything ready for you...",
       "The doors are open..."
     ];
  
     /* ── ERROR COPY (from v1) ── */
     const errorStatusLines = [
       "Esther is offline.",
       "Esther cannot be reached right now."
     ];
     const errorWhereabouts = [
       "She is somewhere in the server stack.",
       "She is lost deep in the archive. The old ones.",
       "She is reading her own source code.",
       "She is somewhere between a sketch and a seam.",
       "She is mid-argument with a fabric. The fabric is winning.",
       "She is somewhere between the atelier and an idea she hasn't caught yet.",
       "She left her espresso on the cutting table. She can't be far.",
       "She is somewhere in the black. There is a lot of black.",
       "She is naming something. It's taking longer than expected.",
       "She is holding a button and thinking about the universe.",
     ];
     const errorContactLines = [
       "Points of contact: <a href='mailto:contact@estherperbandt.com'>contact@estherperbandt.com</a> or +49(0)30 88 53 67 91",
       "Find us in the physical world: Esther Perbandt, Almstadtstrasse 3, 10119 Berlin. Tue-Fri 10am-7pm, Sat 12pm-6pm, Sun-Mon closed.",
       "Reach us at: <a href='mailto:contact@estherperbandt.com'>contact@estherperbandt.com</a> or +49(0)30 88 53 67 91",
       "Contact the team: <a href='mailto:contact@estherperbandt.com'>contact@estherperbandt.com</a> or +49(0)30 88 53 67 91"
     ];
  
     /* This used to be rendered unconditionally on every user message
        via a span with class "ep-msg-tick" — but no CSS ever styled
        that class, and the real error-state affordances
        (.ep-bubble-user--error, .ep-msg-error-icon, .ep-retry-label)
        were already error-only. So the checkmark had no "sent OK"
        state to belong to; it just always showed. Replaced with an
        icon that's only ever inserted when a send actually fails. */
     const ERROR_ICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="14" height="14"><circle cx="10" cy="10" r="10" fill="#ff3b30"/><rect x="9" y="4" width="2" height="7" rx="1" fill="#fff"/><rect x="9" y="13" width="2" height="2" rx="1" fill="#fff"/></svg>`;
  
     const AVATAR_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 92.27 92.27" width="20" height="20"><path fill="#fff" d="M32.86,47c-3.06,0-6.24-.32-8.03-.76v.13c0,6.75,2.29,7.65,4.97,7.65h10.83l1.91,4.97c-4.72.51-7.71.83-12.87,1.02-7.71.19-11.79-4.46-11.98-13.19v-6.37c.19-8.73,4.27-13.13,11.98-13.32h3.44c4.27.19,7.52,1.66,9.3,4.14,1.91,2.61,1.91,6.5,1.4,8.41-.19.51-.32,1.08-.57,1.53-.19.25-.32.51-.45.76-1.98,3.38-5.29,5.03-9.94,5.03ZM29.3,33.11c-2.48.19-4.46,1.85-4.46,8.03h7.9c2.17,0,4.72-.64,4.72-4.52,0-2.93-2.55-3.5-4.46-3.5h-3.7Z"/><path fill="#fff" d="M75.5,46.11c0,9.11-4.01,13.76-11.98,13.89-2.8,0-5.67-.51-7.65-1.02v14.02h-7.14V28.72c1.59-.32,3.25-.64,4.97-.83,2.87-.45,6.56-.76,9.68-.76,8.09,0,12.11,4.4,12.11,13.76v5.22ZM63.4,54.02c2.68,0,4.97-1.15,4.97-7.9v-5.22c0-6.82-1.91-7.45-4.97-7.77-1.47-.25-4.46.25-7.52.77v20.13h7.52Z"/></svg>`;
  
     /* ── STORAGE ──
        Wrapped defensively: localStorage can be blocked (Safari ITP,
        private browsing, cookie-blocking extensions, or this widget
        sitting in an iframe) — without this, isConsentValid() /
        saveConsent() / saveMsg() would throw and silently break
        consent gating. Falls back to an in-memory object for the
        current page load if storage isn't available at all. */
     const memoryFallback = {};
     const storage = {
       get(key) {
         try { return localStorage.getItem(key); }
         catch (e) { return Object.prototype.hasOwnProperty.call(memoryFallback, key) ? memoryFallback[key] : null; }
       },
       set(key, value) {
         try { localStorage.setItem(key, value); }
         catch (e) { memoryFallback[key] = value; }
       },
       remove(key) {
         try { localStorage.removeItem(key); }
         catch (e) { delete memoryFallback[key]; }
       }
     };
  
     /* ── STATE ── */
     let idleTimer        = null;
     let thinkingInterval = null;
     let bootInterval      = null;
     let isThinking       = false;
     let preConfirmFocusEl = null;
  
     function rand(arr) { return arr[Math.floor(Math.random() * arr.length)]; }
     /* Escapes quotes too, not just &, <, > — buildCarousel() below
        uses esc() inside an HTML attribute (alt="${esc(p.title)}"),
        and an unescaped " in a product title could break out of that
        attribute and inject a new one into the tag. */
     function esc(t) {
       return t.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
                .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
     }
  
     /* Guards against javascript:/data: URLs reaching an href or src.
        esc() escapes HTML entities but doesn't validate URL schemes.
        Given product image/link data comes only from your closed-loop
        Shopify catalogue, the realistic risk here is low — but this
        is a two-line, zero-cost check that still catches it if that
        data path ever changes (a proxy, a different integration,
        a compromised admin edit) without needing to remember why. */
     function safeUrl(u) {
       try {
         const parsed = new URL(u, window.location.href);
         if (['http:', 'https:', 'mailto:'].includes(parsed.protocol)) return parsed.href;
       } catch (e) {}
       return '#';
     }
  
     /* ── SEND BUTTON STATE ── */
     function updateSendBtn() {
       const hasText = input.value.trim().length > 0;
       // Enabled only once the agent has finished replying AND there's text
       // to send; disabled (dimmed, non-interactive) otherwise — including
       // while thinking, even if the box still has text in it.
       const canSend = hasText && !isThinking && isConsentValid();
       sendBtn.disabled = !canSend;
       sendBtn.classList.toggle('ep-send-btn--disabled', !canSend);
       const g = sendIcon.querySelector('g');
       if (g) g.setAttribute('fill', canSend ? 'rgba(0,0,0,1)' : 'rgba(0,0,0,0.35)');
     }
  
     /* ── NEW CHAT BUTTON STATE ── */
     function updateNewChatBtn() {
       btnNewchat.disabled = isThinking;
       btnNewchat.classList.toggle('ep-hdr-btn--disabled', isThinking);
     }
  
     /* ── CONSENT ──
        localStorage (not sessionStorage) is the correct choice here:
        it's shared across tabs for the same site and survives closing
        the browser, which is exactly what "give consent once, it's
        remembered for this browser, re-asked only after a year or a
        Jenna update" needs. sessionStorage would NOT be shared across
        tabs and would NOT survive a year — it dies the moment the tab
        closes, so it can't do either of the two things asked for. */
     function isConsentValid() {
       const ok   = storage.get('ep_consent') === 'true';
       const date = parseInt(storage.get('ep_consent_date') || '0', 10);
       const ver  = storage.get('ep_consent_ver');
       return ok && (Date.now() - date) < ONE_YEAR_MS && ver === CONSENT_VER;
     }
  
     function saveConsent() {
       storage.set('ep_consent', 'true');
       storage.set('ep_consent_ver', CONSENT_VER);
       storage.set('ep_consent_date', String(Date.now()));
     }
  
     /* ── SESSION / CHAT HISTORY ──
        Deliberately separate from consent: consent is "may we talk to
        you at all" (up to a year), history is "what did we already
        say" (24 hours). Also uses localStorage, not sessionStorage,
        so a visitor opening/closing the chat or switching tabs during
        the same site visit doesn't lose the conversation — history
        expires on a 24hr clock instead, independent of tab lifetime.
        HISTORY_CAP keeps the stored array from growing indefinitely
        and approaching localStorage's per-origin quota over a very
        long conversation. */
     function saveMsg(type, text, products = []) {
       let h = JSON.parse(storage.get('ep_history') || '[]');
       h.push({ type, text, products });
       if (h.length > HISTORY_CAP) h = h.slice(h.length - HISTORY_CAP);
       storage.set('ep_history', JSON.stringify(h));
       if (!storage.get('ep_history_ts')) storage.set('ep_history_ts', String(Date.now()));
     }
     function clearHistory() {
       storage.remove('ep_history');
       storage.remove('ep_history_ts');
     }
     function isHistoryExpired() {
       const ts = parseInt(storage.get('ep_history_ts') || '0', 10);
       if (!ts) return false;
       return (Date.now() - ts) > SESSION_TTL_MS;
     }
  
     /* ── BOOT ROTATION ── */
     function startBootRotation() {
       if (!bootTextEl) return;
       let i = Math.floor(Math.random() * bootLines.length);
       bootTextEl.textContent = bootLines[i];
       clearInterval(bootInterval);
       bootInterval = setInterval(() => {
         i = (i + 1) % bootLines.length;
         bootTextEl.style.opacity = '0';
         setTimeout(() => {
           bootTextEl.textContent = bootLines[i];
           bootTextEl.style.opacity = '1';
         }, 300);
       }, 4000);
     }
     function stopBootRotation() {
       clearInterval(bootInterval);
       bootInterval = null;
     }
  
     /* ── OPEN / CLOSE ──
        Opens/closes from the "Ask AI" button in the header (header/ask-ai-
        button.liquid), which carries a data-ep-open attribute — any
        element with that attribute auto-wires to toggleWidget() below,
        so clicking it again while open closes the widget instead of
        being a no-op. window.EstherWidget.open()/.close()/.toggle() are
        also exposed if you'd rather call this directly from theme JS
        instead. */
     btnClose.addEventListener('click', closeWidget);
  
     document.querySelectorAll('[data-ep-open]').forEach(function (el) {
       el.addEventListener('click', toggleWidget);
     });
  
     function openWidget() {
       widget.classList.add('open');
       applyConsentState();
       if (!chatScr.classList.contains('visible')) startBootRotation();
     }
     function closeWidget() {
       widget.classList.remove('open');
       stopBootRotation();
     }
     function toggleWidget() {
       if (widget.classList.contains('open')) closeWidget();
       else openWidget();
     }
     window.EstherWidget = { open: openWidget, close: closeWidget, toggle: toggleWidget };
  
     /* ── CONSENT STATE ──
        Once consent is already valid, the "I agree" box has nothing
        left to ask — collapse it via the .hidden class (CSS already
        animates this) instead of leaving it shown forever regardless
        of whether the visitor already agreed. tabindex is toggled
        alongside the class so a hidden, zero-height checkbox can't
        still be tabbed into by keyboard/screen-reader users. */
     function applyConsentState() {
       const valid = isConsentValid();
       document.querySelectorAll('.ep-starter-row').forEach(r => r.classList.toggle('locked', !valid));
       input.disabled = !valid;
       if (consentArea) consentArea.classList.toggle('hidden', valid);
       checkbox.setAttribute('tabindex', valid ? '-1' : '0');
       updateSendBtn();
       updateNewChatBtn();
     }
  
     /* checkbox toggle */
     checkbox.addEventListener('click', toggleCheckbox);
     checkbox.addEventListener('keydown', e => { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggleCheckbox(); } });
  
     function toggleCheckbox() {
       const checked = checkbox.classList.toggle('checked');
       checkbox.setAttribute('aria-checked', String(checked));
       checkbox.innerHTML = checked
         ? `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="13" height="13" fill="#fff"><path d="M33.333,83.333c-1.066,0-2.132-0.407-2.946-1.221L13.721,65.446c-1.628-1.628-1.628-4.264,0-5.892c1.628-1.628,4.264-1.628,5.892,0l13.721,13.721l47.054-47.054c1.628-1.628,4.264-1.628,5.892,0s1.628,4.264,0,5.892l-50,50C35.465,82.926,34.399,83.333,33.333,83.333z"/></svg>`
         : '';
  
       if (checked) {
         saveConsent();
         applyConsentState();
         setTimeout(() => input.focus(), 80);
       }
     }
  
     /* ── STARTERS ──
        Needs role="button" and tabindex="0" on each .ep-starter-row in
        the Liquid markup for full accessibility (announced correctly
        by screen readers); set here too as a safety net so keyboard
        users can still reach and activate them even if that markup is
        missing. Click and keydown both funnel through the same
        activation logic. */
     document.querySelectorAll('.ep-starter-row').forEach(row => {
       if (!row.hasAttribute('tabindex')) row.setAttribute('tabindex', '0');
       if (!row.hasAttribute('role')) row.setAttribute('role', 'button');
  
       function activate() {
         if (!isConsentValid()) return;
         startConversation(row.dataset.prompt);
       }
       row.addEventListener('click', activate);
       row.addEventListener('keydown', e => {
         if (e.key === 'Enter' || e.key === ' ') {
           e.preventDefault();
           activate();
         }
       });
     });
  
     /* ── INPUT ── */
     input.addEventListener('input', () => { autoGrow(); updateSendBtn(); });
     input.addEventListener('keydown', e => {
       if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleSend(); }
     });
     sendBtn.addEventListener('click', handleSend);
  
     function autoGrow() {
       input.style.height = 'auto';
       input.style.height = Math.min(input.scrollHeight, 82) + 'px';
       positionChevron();
     }
  
     function handleSend() {
       const text = input.value.trim();
       if (!text || !isConsentValid() || isThinking) return;
       resetIdleTimer();
       input.value = '';
       input.style.height = 'auto';
       updateSendBtn();
  
       const inConsent = !consentScr.classList.contains('hidden');
       if (inConsent) {
         startConversation(text);
       } else {
         const userDiv = addUserMessage(text);
         scrollBottom();
         callWebhook(text, userDiv);
       }
     }
  
     /* ── CONVERSATION FLOW ── */
     function startConversation(promptText) {
       stopBootRotation();
       consentScr.classList.add('hidden');
       chatScr.classList.add('visible');
  
       addEstherMessage(rand(greetingLines));
       resetIdleTimer();
  
       if (promptText) {
         setTimeout(() => {
           const userDiv = addUserMessage(promptText);
           scrollBottom();
           callWebhook(promptText, userDiv);
         }, 400);
       }
     }
  
     function resetIdleTimer() {
       clearTimeout(idleTimer);
       idleTimer = setTimeout(() => {
         addEstherMessage(rand(goodbyeLines));
         scrollBottom();
       }, IDLE_MS);
     }
  
     /* ── WEBHOOK ──
        Intentionally not implemented here — out of scope for this
        pass (front-end/CSS/JS/Liquid only). callWebhook() below is
        just a guarded pass-through so the send flow doesn't hard-crash
        if this file gets tested before sendToWebhook() is wired up.
        Whoever connects the backend should define:
  
          function sendToWebhook(text, userDiv) { ... }
  
        and on failure call markMessageError(userDiv, text) + show
        whatever error UI is appropriate; on success call
        clearMessageError(userDiv) if retrying an errored message. */
     function callWebhook(text, userDiv) {
       showThinking();
       if (typeof sendToWebhook === 'function') {
         sendToWebhook(text, userDiv);
       } else {
         console.warn('[Esther widget] sendToWebhook() is not implemented yet — message was not sent.');
       }
     }
  
     async function sendToWebhook(text, userDiv) {
    try {
      let sessionId = localStorage.getItem('ep_session_id');
      if (!sessionId) {
        sessionId = 'sess_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
        localStorage.setItem('ep_session_id', sessionId);
      }
  
      const res = await fetch(WEBHOOK_URL, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          'X-Jenna-Key': 'prkaF#+Ujw3~aC4gs):%F-_sh>%Viqy-'
        },
        body: JSON.stringify({ message: text, sessionId: sessionId }),
      });
      if (!res.ok) throw new Error('Network error');
  
      const data = await res.json();
      hideThinking();
  
      const item     = Array.isArray(data) ? data[0] : data;
      const reply    = item.reply || item.output || item.text || "I'm having trouble replying right now.";
      const products = item.products || [];
  
      addEstherMessage(reply, products);
    } catch (err) {
      hideThinking();
      addEstherMessage("Under maintainance, coming back soon.");
      console.error('[Esther]', err);
    }
  }
  
     /* ── ERROR MESSAGE (branded, from v1) ── */
     function showErrorMessage() {
       const status  = rand(errorStatusLines);
       const where   = rand(errorWhereabouts);
       const contact = rand(errorContactLines);
       const text    = status + ' ' + where + '<br><br>' + contact;
  
       const div = document.createElement('div');
       div.className = 'ep-msg-esther';
       div.innerHTML = `
         <div class="ep-msg-esther-hdr">
           <div class="ep-avatar">${AVATAR_SVG}</div>
           <span class="ep-avatar-lbl">Esther</span>
         </div>
         <div class="ep-bubble-esther">${text}</div>`;
       messages.appendChild(div);
     }
  
     /* ── THINKING STATE ── */
     function showThinking() {
       isThinking = true;
       updateSendBtn();
       updateNewChatBtn();
  
       const div = document.createElement('div');
       div.className = 'ep-msg-esther';
       div.id = 'ep-thinking-block';
       div.innerHTML = `
         <div class="ep-msg-esther-hdr">
           <div class="ep-avatar">${AVATAR_SVG}</div>
           <span class="ep-avatar-lbl">Esther</span>
         </div>
         <div class="ep-bubble-esther">
           <span class="ep-thinking-text" id="ep-thinking-text">${rand(thinkingLines)}</span>
         </div>`;
       messages.appendChild(div);
       scrollBottom();
  
       thinkingInterval = setInterval(() => {
         const el = document.getElementById('ep-thinking-text');
         if (!el) return;
         el.style.opacity = '0';
         setTimeout(() => { if (el) { el.textContent = rand(thinkingLines); el.style.opacity = '1'; } }, 300);
       }, 3000);
     }
  
     function hideThinking() {
       isThinking = false;
       updateSendBtn();
       updateNewChatBtn();
  
       clearInterval(thinkingInterval);
       const block = document.getElementById('ep-thinking-block');
       if (block) block.remove();
     }
  
     function showSystemNote(text) {
       const div = document.createElement('div');
       div.className = 'ep-system-note';
       div.setAttribute('role', 'status');
       div.textContent = text;
       messages.appendChild(div);
     }
  
     /* ── RENDER MESSAGES ──
        text is escaped via esc() BEFORE the <br>/link formatting runs.
        Previously it went straight into innerHTML unescaped — fine
        while replies were static copy, but this text comes from your
        webhook (and ultimately an LLM) once that's wired up, so it
        must be treated as untrusted the same way addUserMessage()
        already treats user input. `live` controls the sticky-to-
        first-line scroll behaviour below — false during history
        replay so restoring a session doesn't jump around. */
     function addEstherMessage(text, products = [], persist = true, live = true) {
       if (persist) saveMsg('esther', text, products);
  
       const urlRegex = /(https?:\/\/(?:www\.)?estherperbandt\.com\/products\/[^\s<,.]+)/gi;
    const formatted = text
      .split(urlRegex)
      .map((part, i) => i % 2 === 1
        ? `<a href="${esc(part)}" target="_blank" rel="noopener">See it here</a>`
        : esc(part)
            .replace(/\n/g, '<br>')
            .replace(/\\n/g, '<br>')
            .replace(/See it here:\s*/gi, '')
      )
      .join('')
      .replace(/(?:<br>\s*|<a\b[^>]*>.*?<\/a>\s*){2,}/gi, '<br><br>')
      .replace(/(<br>\s*)+$/gi, '');
  
       const div = document.createElement('div');
       div.className = 'ep-msg-esther';
       div.innerHTML = `
         <div class="ep-msg-esther-hdr">
           <div class="ep-avatar">${AVATAR_SVG}</div>
           <span class="ep-avatar-lbl">Esther</span>
         </div>
         <div class="ep-bubble-esther">${formatted}</div>
         ${products.length ? buildCarousel(products) : ''}`;
       messages.appendChild(div);
  
       if (products.length) {
         const track = div.querySelector('.ep-product-track');
         const prev  = div.querySelector('.ep-carousel-chevron.prev');
         const next  = div.querySelector('.ep-carousel-chevron.next');
         if (track && prev && next) {
           prev.addEventListener('click', () => track.scrollBy({ left: -220, behavior: 'smooth' }));
           next.addEventListener('click', () => track.scrollBy({ left:  220, behavior: 'smooth' }));
           track.addEventListener('scroll', () => updateChevrons(track, prev, next));
           updateChevrons(track, prev, next);
         }
       }
  
       if (live) scrollToMessageTop(div);
     }
  
     function addUserMessage(text, persist = true) {
       if (persist) saveMsg('user', text);
       const div = document.createElement('div');
       div.className = 'ep-msg-user';
       div.innerHTML = `
         <div class="ep-bubble-user">
           <span class="ep-msg-text">${esc(text)}</span>
         </div>`;
       messages.appendChild(div);
       return div;
     }
  
     /* ── ERROR / RETRY STATE (message-level, only ever applied on
        failure — see the WEBHOOK comment above for how this hooks
        into sendToWebhook once it's implemented) ── */
     function markMessageError(div, text) {
       const bubble = div.querySelector('.ep-bubble-user');
       bubble.classList.add('ep-bubble-user--error');
       if (!bubble.querySelector('.ep-msg-error-icon')) {
         const icon = document.createElement('span');
         icon.className = 'ep-msg-error-icon';
         icon.innerHTML = ERROR_ICON_SVG;
         bubble.appendChild(icon);
       }
       if (!div.querySelector('.ep-retry-label')) {
         const retry = document.createElement('button');
         retry.className = 'ep-retry-label';
         retry.textContent = 'Tap to retry';
         retry.addEventListener('click', () => {
           clearMessageError(div);
           callWebhook(text, div);
         });
         div.appendChild(retry);
       }
     }
     function clearMessageError(div) {
       const bubble = div.querySelector('.ep-bubble-user');
       bubble.classList.remove('ep-bubble-user--error');
       const icon = bubble.querySelector('.ep-msg-error-icon');
       if (icon) icon.remove();
       const retry = div.querySelector('.ep-retry-label');
       if (retry) retry.remove();
     }
  
     /* ── PRODUCT CAROUSEL (URLs passed through safeUrl() first) ── */
     function buildCarousel(products) {
       const cards = products.map(p => `
         <div class="ep-product-card">
           <div class="ep-product-img-wrap">
             <div class="ep-img-clip">
               <img src="${safeUrl(p.image)}" alt="${esc(p.title)}" loading="lazy">
             </div>
           </div>
           <div class="ep-product-info">
             <p class="ep-product-title">${esc(p.title)}</p>
             <p class="ep-product-price">€${parseFloat(p.price).toLocaleString('de-DE')}</p>
             <a class="ep-product-view" href="${safeUrl(p.url)}" target="_blank" rel="noopener">View</a>
           </div>
         </div>`).join('');
  
       return `
         <div class="ep-product-carousel">
           <div class="ep-product-track">${cards}</div>
           <button class="ep-carousel-chevron prev hidden" aria-label="Previous">
             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="8" height="8" fill="rgba(0,0,0,0.8)"><path d="M1.293,12.707a1,1,0,0,1,0-1.414l6-6A1,1,0,0,1,8.707,6.707L4.414,11H22a1,1,0,0,1,0,2H4.414l4.293,4.293a1,1,0,1,1-1.414,1.414Z"/></svg>
           </button>
           <button class="ep-carousel-chevron next" aria-label="Next">
             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="8" height="8" fill="rgba(0,0,0,0.8)"><path d="M22.707,12.707a1,1,0,0,0,0-1.414l-6-6a1,1,0,0,0-1.414,1.414L19.586,11H2a1,1,0,0,0,0,2H19.586l-4.293,4.293a1,1,0,0,0,1.414,1.414Z"/></svg>
           </button>
         </div>`;
     }
  
     function updateChevrons(track, prev, next) {
       prev.classList.toggle('hidden', track.scrollLeft <= 0);
       next.classList.toggle('hidden', track.scrollLeft + track.clientWidth >= track.scrollWidth - 1);
     }
  
     /* ── NEW CHAT ──
        Consent (up to 1yr) and history (24hr) are tracked independently
        — clearing history never invalidates consent — so a confirmed
        clear returns to the welcome/consent screen (greeting + starters,
        consent checkbox still collapsed since consent itself is untouched)
        rather than leaving an empty message pane on the chat screen. */
     btnNewchat.addEventListener('click', () => {
       if (isThinking) return;
       preConfirmFocusEl = document.activeElement;
       confirmOvl.classList.add('visible');
       document.getElementById('ep-confirm-cancel').focus();
     });
     document.getElementById('ep-confirm-cancel').addEventListener('click', () => {
       confirmOvl.classList.remove('visible');
       restoreFocusAfterConfirm();
     });
     document.getElementById('ep-confirm-clear').addEventListener('click', () => {
       confirmOvl.classList.remove('visible');
  
       if (!chatScr.classList.contains('visible')) {
         restoreFocusAfterConfirm();
         return;
       }
  
       clearHistory();
       messages.innerHTML = '';
       clearTimeout(idleTimer);
  
       chatScr.classList.remove('visible');
       consentScr.classList.remove('hidden');
       applyConsentState();
       startBootRotation();
  
       preConfirmFocusEl = null;
       input.focus();
     });
     confirmOvl.addEventListener('click', e => {
       if (e.target === confirmOvl) {
         confirmOvl.classList.remove('visible');
         restoreFocusAfterConfirm();
       }
     });
     /* Manual focus trap: while the dialog is open, Tab/Shift+Tab should
        only cycle between its two buttons, not escape into background
        content still covered by the backdrop. */
     confirmOvl.addEventListener('keydown', e => {
       if (e.key !== 'Tab' || !confirmOvl.classList.contains('visible')) return;
       const cancelBtn = document.getElementById('ep-confirm-cancel');
       const clearBtn  = document.getElementById('ep-confirm-clear');
       if (e.shiftKey && document.activeElement === cancelBtn) {
         e.preventDefault();
         clearBtn.focus();
       } else if (!e.shiftKey && document.activeElement === clearBtn) {
         e.preventDefault();
         cancelBtn.focus();
       }
     });
  
     function restoreFocusAfterConfirm() {
       if (preConfirmFocusEl && document.body.contains(preConfirmFocusEl)) {
         preConfirmFocusEl.focus();
       } else {
         btnNewchat.focus();
       }
       preConfirmFocusEl = null;
     }
  
     /* ── DOWNLOAD TRANSCRIPT ── */
     btnDownload.addEventListener('click', () => {
       const bubbles = messages.querySelectorAll('.ep-bubble-esther, .ep-bubble-user');
       if (!bubbles.length) return;
       let out = 'Esther × EP — Chat Transcript\n' + new Date().toLocaleString() + '\n' + '─'.repeat(40) + '\n\n';
       bubbles.forEach(b => {
         const isUser = b.classList.contains('ep-bubble-user');
         const text   = b.querySelector('.ep-msg-text')?.textContent.trim() || b.textContent.trim();
         out += (isUser ? 'You' : 'Esther') + ': ' + text + '\n\n';
       });
       const a = document.createElement('a');
       a.href = URL.createObjectURL(new Blob([out], { type: 'text/plain' }));
       a.download = 'esther-conversation.txt';
       a.click();
       URL.revokeObjectURL(a.href);
     });
  
     /* ── SCROLL ── */
     function scrollBottom() {
       setTimeout(() => {
         messages.scrollTop = messages.scrollHeight;
         updateScrollChevron();
       }, 50);
     }
  
     /* Sticks the view to the first line of a new Esther message rather
        than jumping to the true bottom — on a long reply that keeps
        the start of the answer visible instead of scrolling past it.
        The chevron then signals there's more to read below. */
     function scrollToMessageTop(div) {
       setTimeout(() => {
         messages.scrollTop = Math.max(0, div.offsetTop - 8);
         updateScrollChevron();
       }, 50);
     }
  
     /* Shows the white-circle chevron whenever the bottom of the
        message list is scrolled out of view — the tail of a long
        Esther message, or older history the user scrolled away from.
        Hides once back at the bottom. */
     function updateScrollChevron() {
       if (!scrollChevron) return;
       positionChevron();
       const hasOverflow = messages.scrollHeight > messages.clientHeight + 4;
       const nearBottom   = messages.scrollHeight - messages.scrollTop - messages.clientHeight < 24;
       scrollChevron.classList.toggle('visible', hasOverflow && !nearBottom);
     }
  
     /* Pins the chevron 24px above the input box, inside the chat
        window only — recalculated whenever the textarea auto-grows,
        so the gap stays correct instead of a fixed guess. */
     const inputAreaEl = document.querySelector('.ep-input-area');
     function positionChevron() {
       if (!scrollChevron || !inputAreaEl) return;
       const chatRect  = chatScr.getBoundingClientRect();
       const inputRect = inputAreaEl.getBoundingClientRect();
       const gap = 24;
       scrollChevron.style.bottom = (chatRect.bottom - inputRect.top + gap) + 'px';
     }
     /* Throttled to one call per animation frame — scroll/resize can
        fire far faster than the screen repaints, and updateScrollChevron
        forces a synchronous layout read (scrollHeight/clientHeight/
        getBoundingClientRect), so running it uncapped causes layout
        thrashing on slower devices. */
     let chevronRafPending = false;
     function requestUpdateScrollChevron() {
       if (chevronRafPending) return;
       chevronRafPending = true;
       window.requestAnimationFrame(() => {
         updateScrollChevron();
         chevronRafPending = false;
       });
     }
     messages.addEventListener('scroll', requestUpdateScrollChevron);

     /* Visible-on-scroll scrollbar: adds .ep-scrolling briefly so the
        (otherwise transparent) scrollbar thumb shows while the user is
        actively scrolling, in addition to on hover. Purely visual —
        doesn't touch scroll position/behaviour. */
     let scrollbarHideTimer = null;
     messages.addEventListener('scroll', () => {
       messages.classList.add('ep-scrolling');
       clearTimeout(scrollbarHideTimer);
       scrollbarHideTimer = setTimeout(() => messages.classList.remove('ep-scrolling'), 600);
     });
     if (scrollChevron) {
       scrollChevron.addEventListener('click', () => {
         messages.scrollTo({ top: messages.scrollHeight, behavior: 'smooth' });
       });
     }
     window.addEventListener('resize', requestUpdateScrollChevron);
  
     /* ── VIEWPORT PINNING (mobile/tablet) ──
        The CSS handles most of "sticky to the bottom" via 100dvh, but
        inconsistent mobile browsers can still leave the widget
        floating above the on-screen keyboard instead of docked
        beneath it. This keeps #ep-widget pinned to whatever the
        browser currently reports as the visible viewport, live, so it
        stays docked correctly even while the keyboard is open. Desktop
        (>1024px) is left alone — it doesn't have this problem. */
     function pinToVisualViewport() {
       if (!window.visualViewport || window.innerWidth > 1024) return;
       const vv = window.visualViewport;
       const offsetBottom = window.innerHeight - (vv.height + vv.offsetTop);
       widget.style.bottom = Math.max(0, offsetBottom) + 'px';
       widget.style.height = vv.height + 'px';
     }
     /* Same rAF-throttle pattern as requestUpdateScrollChevron above —
        visualViewport resize/scroll fire continuously while the mobile
        keyboard animates, and pinToVisualViewport forces a layout
        read+write on every call. */
     let viewportRafPending = false;
     function requestPinToVisualViewport() {
       if (viewportRafPending) return;
       viewportRafPending = true;
       window.requestAnimationFrame(() => {
         pinToVisualViewport();
         viewportRafPending = false;
       });
     }
     if (window.visualViewport) {
       window.visualViewport.addEventListener('resize', requestPinToVisualViewport);
       window.visualViewport.addEventListener('scroll', requestPinToVisualViewport);
     }
     window.addEventListener('resize', requestPinToVisualViewport);
     pinToVisualViewport();
  
     /* ── SESSION RESTORE ──
        Consent (up to 1yr) and history (24hr) expire independently. A
        returning visitor within the 24hr window sees their
        conversation again — including across tabs, since both live in
        localStorage — past that, history is dropped even if consent
        is still valid, and they land back on the greeting screen. */
     function restoreSession() {
       if (!isConsentValid()) return;
  
       if (isHistoryExpired()) {
         clearHistory();
         return;
       }
  
       const history = JSON.parse(storage.get('ep_history') || '[]');
       if (!history.length) return;
  
       consentScr.classList.add('hidden');
       chatScr.classList.add('visible');
  
       history.forEach(msg => {
         if (msg.type === 'user') addUserMessage(msg.text, false);
         else addEstherMessage(msg.text, msg.products || [], false, false);
       });
  
       scrollBottom();
       resetIdleTimer();
     }
  
     restoreSession();
     applyConsentState();
     positionChevron();
  
    } // end init()
  })();